//
//
//
//
//
//
//
//

import BusinessMgr from './ManagerModules/BusinessMgr.vue';
import ProductMgr from './BusinessModules/ProductMgr.vue';
import SearchPage from './SearchPage.vue';

export default {
  components: {
    'business-mgr':BusinessMgr,
    'product-mgr':ProductMgr,
    'search-page':SearchPage
  },
  mounted() {
    if(this.GLOBAL.currentUser==undefined){
      this.$router.push({ path: '/' });
    }
    let tag= this.$route.query.tag;
    if(tag=='M'){
      this.isManager=true;
      this.isBusiness=false;
      this.isearch=false;
    }
    else if(tag=='B'){
      this.isManager=false;
      this.isBusiness=true;
      this.isearch=false;
    }
  },
  methods: {
  },
  data () {
    return {
      isManager:false,
      isBusiness:true,
      isearch:false
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/MainPage.vue